<template>
  <qc-container :title="title">
    <page-request ref="table" url="/api/mgr/store/shop/info/list" :table-header="tableHeader" :expend="expend" :prop="{shopType:type}" :op-width="200">
      <template #op="scope">
        <b-button v-if="scope.row.status==0" @click="toDetail(scope.row)">审核</b-button>
        <b-button v-else @click="toDetail(scope.row)">查看</b-button>
      </template>
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";

export default {
  components: {TButton, BButton, PageRequest, QcContainer},
  props:{
    title:String,
    //类型 0加盟商 1门店
    type:{
      type:Number,
      default:0
    }
  },
  name: "shop-audit-list",
  data() {
    return {
      tableHeader: [
        {type: "selection", label: ""},
        {type: "shop", label: "商家",width:200},
        {prop: "address", label: "详细地址"},
        {label: "状态",renderDraw:row=>{
          if(row.status===0) {
            return "待审核";
          }else if(row.status===1) {
            return "通过";
          }else if(row.status===2) {
            return "驳回";
          }
          },width: 100},
        {prop: "errorMsg", label: "原因"},
        {prop: "createTime", label: "提交时间",width: 160}
      ],
      expend:[
        {label: "商家名称",prop: "shopName"},
        {label: "商家ID",prop: "shopCode"},
        {label: "手机号码",prop: "storePhone"},
        {label: "审核状态", prop: "status",type:"select",options:[{"label":"待审核","value":"0"},{"label":"通过","value":"1"},{"label":"驳回","value":"2"}]},
        {label: "申请时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ]
    }
  },
  mixins: [tableBase],
  methods: {
    toDetail(row) {
      this.toRouter("/index/shop/audit/detail",{id:row.id,type:row.shopType})

    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
